import React from "react";
import styled from 'styled-components';
import ClaroImage from '../../../molecules/ClaroImage'
import InputTitleClaroSocio from '../../../molecules/InputTitleClaroSocio';
import InputSubTitleClaroSocio from '../../../molecules/InputSubtitleClaroSocio';
import { getImageCard } from '../utils/index';
import ClaroInputField from "../../../atoms/ClaroInputField";
import SelectInputSears from "../../../organisms/inputsClaroSocio/SelectInputSears";
import ClaroDiv from "../../../atoms/ClaroDiv";
import ClaroInputButton from "../../../atoms/ClaroInputButton"
import { validateUserAgent } from "../../utils";

const Container = styled.div`
    width: 96%;
    background: ${props => props.background ? props.background : "#fff"};
    margin: ${props => props.margin ? props.margin : "2%"};
`;

const TextOption = styled.p`
    color: #7f7d7f;
    font-size: 12px;
    font-weight: normal;
    display: inline;
    vertical-align: "middle";
    padding: ${props => props.padding ? props.padding : "0% 0% 0% 0%"};
    font-family: ${props => props.fontFamily ? props.fontFamily : "Roboto"};
`;

class SelectInputClaroSocio extends React.Component {
    constructor(props){
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        //console.log(this.props, "en el Chip input");
    }

    render(){

        const validInvalidColor =  '#323232'
        const borderValidInvalidColor = !this.props.isContainerTelcel ? '1px solid #26012024' : "1px solid #bac9d8"
        const stylesButton = {
            "src": this.props.isContainerTelcel ? "/images/icono_flecha_detalle_claropay_contenedor.png" : "/images/icono_flecha_detalle_claro_pay.svg",
            "srcImgClaroSocio": "/images/icono_flecha_detalle.svg",
            "align": {
                "center": true
            },
            "height": this.props.isContainerTelcel && !this.props.isClaroPartner ? "28px" : "15.1em",
            "width": this.props.isContainerTelcel && !this.props.isClaroPartner ? "28px" : "25em",
            "alt": "",
            "padding": "0% 0% 0% 0%",
        }
        const styles = {
            "color": `${validInvalidColor}`,
            borderBottom: borderValidInvalidColor
        }

        let id = "pagoDeServicios_" + this.props.input.id + "_" + this.props.serviceName;
        let mark = this.props.mark;
        let valueString = "";
        const {withClaroInputField}= this.props
        if( mark == "" || mark == undefined){
            valueString = this.props.input.field.input.placeholder;
        } else if(mark == "999"){
            valueString = "";
        } else if(mark == "997"){
            valueString = "";
        } else if(mark == "996"){
            valueString = "";
        } else {
            valueString = "****** ";
        } 

        let imageCard = getImageCard(mark);  
        
        return(
            <Container 
                    background={this.props.isContainerTelcel && !this.props.isClaroPartner ? "#fff" : undefined}
                    margin={this.props.isContainerTelcel && !this.props.isClaroPartner ? "2% 2% 15px 2%" : undefined}
                >
                <InputTitleClaroSocio 
                    {...this.props.input.title} 
                    type={this.props.input.type} 
                    handleClickTooltip={this.props.handleClickTooltip}
                    isClaroPartner = {this.props.isClaroPartner}
                    logicType={this.props.logicType}
                    isContainerTelcel={this.props.isContainerTelcel}
                />
                {
                    (this.props.logicType == "sears")?
                        <SelectInputSears
                            imageCard = {imageCard}
                            mark = {mark}
                            input={this.props.input} 
                            constraints={this.props.constraints} 
                            value= { valueString + this.props.value} 
                            name={this.props.input.field.input.name}
                            id = {id}
                            handleInputButtonFunction= {this.props.handleInputButtonFunction}
                            borderBottom={borderValidInvalidColor} 
                        
                        />:
                        <ClaroDiv  
                            {...styles}
                            role="button"
                            tabIndex={0}
                            aria-label="Elige tu método de pago"
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    this.props.handleInputButtonFunction(e, this.props.input.type);
                                }
                            }}
                            onClick= {(e) =>{
                                this.props.handleInputButtonFunction(e, this.props.input.type);
                            }}
                        >
                        {
                            imageCard && !this.props.isContainerTelcel ?
                                <div style={{ paddingRight:"10px", minHeight:"34.5px", borderBottom: borderValidInvalidColor}} >
                                    <img 
                                        src= {imageCard } 
                                        height="22px" 
                                        width={mark === "996" ? "" : "40px"}
                                        style={{paddingTop: "4px"}}
                                    />
                                </div>
                            :
                            <></>
                        }
                        {
                            mark == "999"?
                                <div style={{minHeight:"34.5px", borderBottom: borderValidInvalidColor}}>
                                    <img 
                                        src= {"/images/logo_n2_inbursa.png"} 
                                        height="14px" 
                                        width={validateUserAgent() === "android" ? "90%" : "auto"}
                                        style={{paddingTop: "3%"}}
                                    />
                                </div>
                            :
                            <></>
                        }
                        {
                            mark == "997"?
                                <div style={{minHeight:"34.5px", borderBottom: borderValidInvalidColor}}>
                                <TextOption fontFamily={this.props.isContainerTelcel ? "AMX-Regular" : undefined}>{ "Crédito" }</TextOption>
                                    <img 
                                        src= {"/images/logo_n2_no_inbursa.png"} 
                                        height="14px" 
                                        style={{marginLeft: '5px'}}
                                    />
                                </div>
                            :
                            <></>
                        }
                        <ClaroInputField 
                            width={withClaroInputField?withClaroInputField:"auto"}
                            {...this.props.input} 
                            {...styles} 
                            constraints={this.props.constraints} 
                            value= { valueString + this.props.value} 
                            name={this.props.input.field.input.name}
                            id = {id}
                            readOnly={true}
                            fontFamily={this.props.isContainerTelcel ? "AMX-Regular" : undefined}
                        />
                        {
                            <ClaroInputButton
                                borderBottom={borderValidInvalidColor} 
                                {...stylesButton}
                                onClick= {(e) =>{this.props.handleInputButtonFunction(e, this.props.input.type)}}
                            >
                            {
                                <ClaroImage {...stylesButton} isClaroPartner={this.props.isClaroPartner} widthClaroSocio={"15em"}/>
                            }
                            </ClaroInputButton>
                        }
                    </ClaroDiv>
                }
                <InputSubTitleClaroSocio {...this.props.input.subTitle} type={this.props.input.type} />
            </Container>
        )
    }
}

export default SelectInputClaroSocio;